import { lazy, Suspense } from 'react'
import { Sparkles } from 'lucide-react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ActivatedRoute } from './components/RouteGuard'
import { loadQuizPage } from './loaders/quizPage'
import { ActivatePage } from './pages/ActivatePage'
import { HomePage } from './pages/HomePage'
import { loadResultPage } from './loaders/resultPage'

const QuizPage = lazy(() => loadQuizPage().then((module) => ({ default: module.QuizPage })))
const ResultPage = lazy(() => loadResultPage().then((module) => ({ default: module.ResultPage })))
const PromotionResultPage = lazy(() => import('./pages/PromotionResultPage').then((module) => ({ default: module.PromotionResultPage })))
const ReportPage = lazy(() => import('./pages/ReportPage').then((module) => ({ default: module.ReportPage })))

const protectedPage = (page: React.ReactNode) => <ActivatedRoute>{page}</ActivatedRoute>

export function App() {
  return (
    <Suspense fallback={<main className="loading-page"><Sparkles className="pulse" /><p>正在打开电影场景…</p></main>}>
      <Routes>
        <Route path="/activate" element={<ActivatePage />} />
        <Route path="/home" element={protectedPage(<HomePage />)} />
        <Route path="/quiz/:index" element={protectedPage(<QuizPage />)} />
        <Route path="/result" element={protectedPage(<ResultPage />)} />
        <Route path="/r/:promotionId" element={<PromotionResultPage />} />
        <Route path="/report/:movieId" element={protectedPage(<ReportPage />)} />
        <Route path="*" element={<Navigate to="/activate" replace />} />
      </Routes>
    </Suspense>
  )
}
